import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetconsumptionReducer(state = initialState.budgetconsumptionContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETCONSUMPTIONCONTENT_SUCCESS:
      return action.budgetconsumptionContent;
    default:
      return state;
  }
}
